import { handleErrorAxios } from "@/common/lib/formatter";
import Http from "@/common/lib/http";

const request = async ({ commit, dispatch }, call) => {
    try {
        const { data } = await call();
        return data;
    } catch (errorAxios) {
        const parseError = handleErrorAxios(errorAxios, dispatch);
        commit("SET_ERROR_PLATFORM_SUBSCRIPTIONS", parseError);
        throw parseError;
    }
};

const actions = {
    // Super: estado + historial de la subscripción de un tenant.
    getTenantSubscription(context, { tenantId }) {
        return request(context, () =>
            Http.instance.get(`/bo/tenants/${tenantId}/subscription`)
        );
    },
    // Super: planes asignables (Free y pruebas).
    getTenantPlans(context, { tenantId }) {
        return request(context, () =>
            Http.instance.get(`/bo/tenants/${tenantId}/plans`)
        );
    },
    // Super: asignar Free o una prueba ({ planSlug, mode: "trial" }).
    assignTenantSubscription(context, { mode, planSlug, tenantId }) {
        return request(context, () =>
            Http.instance.post(`/bo/tenants/${tenantId}/subscription`, {
                planSlug,
                ...(mode && { mode })
            })
        );
    },
    // Super: facturas de un tenant, de la más reciente a la más vieja.
    listTenantPlatformInvoices(context, { tenantId }) {
        return request(context, () =>
            Http.instance.get(`/bo/tenants/${tenantId}/invoices`)
        );
    },
    extendTenantSubscriptionPeriod(context, { days, subscriptionId }) {
        return request(context, () =>
            Http.instance.post(
                `/bo/platform-subscriptions/${subscriptionId}/extend-period`,
                { days }
            )
        );
    },
    // Owner: { current, scheduled, pendingChange, payableInvoice, actions }.
    getMySubscription(context) {
        return request(context, () =>
            Http.instance.get("/bo/platform-subscriptions/mine")
        );
    },
    // Owner: dice qué pasaría con el cambio, sin escribir nada.
    previewMyPlanChange(context, { planSlug }) {
        return request(context, () =>
            Http.instance.post(
                "/bo/platform-subscriptions/mine/change-plan/preview",
                { planSlug }
            )
        );
    },
    // Owner: ejecuta el cambio (subir, bajar, cancelar o deshacer).
    changeMyPlan(context, { planSlug }) {
        return request(context, () =>
            Http.instance.post("/bo/platform-subscriptions/mine/change-plan", {
                planSlug
            })
        );
    },
    // Owner: facturas del tenant de la sesión.
    listMyPlatformInvoices(context) {
        return request(context, () =>
            Http.instance.get("/bo/platform-invoices/mine")
        );
    },
    payPlatformInvoice(context, { id }) {
        return request(context, () =>
            Http.instance.post(`/bo/platform-invoices/${id}/pay`)
        );
    },
    // { status, paid, paymentStatus, source }: usado por las páginas de
    // retorno del pago. paymentStatus: approved|rejected|failed|pending|expired;
    // source: onboarding|my_plan.
    getPlatformInvoiceStatus(context, { id }) {
        return request(context, () =>
            Http.instance.get(`/bo/platform-invoices/${id}/status`)
        );
    },
    listActivePlatformPlans(context) {
        return request(context, () => Http.instance.get("/bo/platform-plans"));
    },
    // billing-fase5-salida-planes: planes para saber qué desbloquea cada
    // feature o tope (modal "Pásate a…", candados, comparativa).
    async loadPlanCatalog(context) {
        const { items } = await request(context, () =>
            Http.instance.get("/bo/platform-plans")
        );
        context.commit("SET_PLAN_CATALOG", items);
        return items;
    },
    // portal-sesion-y-candados-optimizacion: el catálogo se pide solo
    // cuando se usa (modal "Pásate a…", pantallas de plan) y una vez por
    // carga de la app.
    async ensurePlanCatalog(context) {
        if (context.state.planCatalog.length) {
            return context.state.planCatalog;
        }
        return context.dispatch("loadPlanCatalog");
    },
    openPlanUpgrade({ commit }, prompt) {
        commit("SET_UPGRADE_PROMPT", prompt);
    },
    closePlanUpgrade({ commit }) {
        commit("SET_UPGRADE_PROMPT", null);
    }
};

export default actions;
